import { ctxReport } from '@/contexts/ReportCtx';
import { useState, useEffect, useContext } from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Button } from '@mui/material';
import { getAvailableReports } from '@/generated/client/reports/reports';
import { ReportTabs } from './ReportPopup';
import { ReportTabValue } from '@/types';
import { useTranslation } from 'react-i18next';

export function ReportMobileFooter({
  activeTab,
  setActiveTab,
}: {
  activeTab: ReportTabs;
  setActiveTab: (tab: ReportTabs) => void;
}) {
  const [loading, setLoading] = useState(false);
  const [reportsLength, setReportsLength] = useState(0);

  const reportCtx = useContext(ctxReport);
  const { t } = useTranslation();

  const selectedTargets = reportCtx?.selectedTargets ?? [];
  const selectedDrivers = reportCtx?.selectedDrivers ?? [];
  const selectedDates = reportCtx?.selectedDates;
  const hasSelectedItem = activeTab === 'TargetTab' ? selectedTargets.length > 0 : selectedDrivers.length > 0;

  function forwardToReportData() {
    setActiveTab(selectedTargets.length > 0 ? 'TargetReportTab' : 'DriverReportTab');
    reportCtx?.setTab(ReportTabValue.result);
  }

  useEffect(() => {
    if (!reportCtx) return;
    if (!hasSelectedItem) return;
    if (!selectedDates) return;
    if (loading) return;

    async function load() {
      setLoading(true);
      const request = {
        targetIds: activeTab === 'TargetTab' ? selectedTargets.map((t) => t.id) : [],
        driverIds: activeTab === 'DriverTab' ? selectedDrivers.map((d) => d.id) : [],
        fromTimeMicros: selectedDates!.from.getTime() * 1000,
        toTimeMicros: selectedDates!.to.getTime() * 1000,
      };

      const response = await getAvailableReports(request);
      setLoading(false);
      setReportsLength(response.data.length);
    }

    void load();
  }, [selectedTargets, selectedDrivers, selectedDates]);

  if (!reportCtx) return null;
  if (reportCtx.tab !== ReportTabValue.entitySelect) return null;
  if (!hasSelectedItem) return null;

  return (
    <div className="report-footer">
      <div className="available-reports">
        {t('report.availableReports')} ({reportsLength})
      </div>
      {reportsLength > 0 && (
        <div className="forward-button-container">
          <Button
            data-qa-element-id="forward_button"
            variant="contained"
            color="secondary"
            onClick={forwardToReportData}
            className="report-generate-button"
          >
            {t('general.next')}
            <ArrowForward />
          </Button>
        </div>
      )}
    </div>
  );
}
